import React from "react";
import IMAGES from "@/public/assets/img";
import Image from "next/image";
const ExportTrustSection = () => {
  return (
    <section className="py-[100px]">
      <div className="container xm:px-2 px-3">
        <div className="flex justify-between items-center sm:flex-col">
          {/* Left: Triangle */}
          <div className="w-1/2 sm:w-full">
            <Image
              src={IMAGES?.termsheet?.chartTermsheet}
              alt="Chart"
              width={566}
              height={243}
            />
          </div>

          {/* Right Content */}
          <div className="w-2/5 sm:w-full sm:mt-6">
            <h2 className="text-xxl sm:text-xxl sm:leading-9 font-bold mb-4">
              Don’t Risk Your Export
            </h2>
            <p className="text-xl mb-xsp text-black">
              Verify your buyer's creditworthiness today!
            </p>
            <p className="text-xl text-[#6F6F6F]">
              Join thousands of Indian exporters trusting Credlix for a
              risk-free export journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExportTrustSection;
